import React from 'react'

import { FormHelperText, Grid } from '@mui/material'
import CustomInpuText from '../../customInputText/CustomInputText'
import PrimaryButton from '../../primaryButton/PrimaryButton'
import Rating from '@mui/material/Rating'

import { useStyles } from './styles'
import Indicators from '../../indicators/Indicators'
import useValidation from '../../../hooks/useValidation'

const Step5 = ({
  btnAction,
  handleGoto,
  handleChange,
  data,
  cantItems,
  current,
}) => {
  const classes = useStyles()

  const validationsSchema = {
    testimonial: {
      valid: data.rate && data.rate > 3 ? data.testimonial || false : true,
      errorMsg: 'Please fill this field.',
      validate: (v) => (data.rate && data.rate > 3 ? v || false : true),
    },
    rate: {
      valid: data.rate ? data.rate > 0 : false,
      errorMsg: 'Please provide a rating.',
      validate: (v) => (v ? v > 0 : false),
    },
    dateTime: {
      valid: data.dateTime || false,
      errorMsg: 'Please provide a dateTime.',
      validate: (value) => value || false,
    },
  }

  const { errors, validate, validateAll } = useValidation(validationsSchema)

  const handleInternalChange = (evt) => {
    const { name, value } = evt.target
    handleChange(evt)
    validate(name, value)
  }

  const handleRateChange = (evt, value) => {
    const name = 'rate'
    handleChange({
      target: {
        name,
        value,
      },
    })
    validate(name, value)
  }

  const handleInternalBtnAction = (evt) => {
    if (validateAll()) {
      btnAction(evt)
    }
  }

  const handleInternalGoto = (index) => {
    if (index < data.step || validateAll()) {
      handleGoto(index)
    }
  }

  return (
    <Grid container spacing={2} className={classes.wrapper}>
      <Grid item xs={12}>
        <p className={classes.formTitle}>
          How would you rate your experience with Seacrest Services?
        </p>
        <Rating name='rate' value={data.rate} onChange={handleRateChange} />
        {errors?.rate && <FormHelperText error>{errors?.rate}</FormHelperText>}
      </Grid>
      {data.rate > 3 ? (
        <Grid item xs={12}>
          <div className='static-label-wrapper'>
            <p className='static-label'>
              Thank you so much. Would you mind leaving us a review?
            </p>
          </div>
          <CustomInpuText
            className={classes.noPadTextarea}
            placeholder='Would you like to submit a testimonial?'
            multiline
            rows={8}
            name='testimonial'
            value={data.testimonial}
            onChange={handleInternalChange}
            error={errors?.testimonial ? true : false}
            helperText={errors?.testimonial || ''}
          />
        </Grid>
      ) : data.rate > 0 ? (
        <Grid item xs={12}>
          <p className={classes.formTitle}>
            Thank you for your feedback. We appreciate it and will be in touch.
          </p>
        </Grid>
      ) : null}
      <Grid
        container
        item
        xs={12}
        sm={6}
        lg={6}
        justifyContent='center'
        alignItems='flex-end'
        sx={{ display: { sm: 'none', xs: 'flex' } }}
      >
        <Indicators
          cantItems={cantItems}
          current={current}
          handleGoto={handleInternalGoto}
        />
      </Grid>

      <Grid item xs={12} sm={6} className={classes.btnWrapper}>
        <PrimaryButton
          type=' submit'
          onClick={handleInternalBtnAction}
          disabled={data.loading}
          className={classes.btnSubmit}
        >
          Submit Feedback
        </PrimaryButton>
      </Grid>
      <Grid
        container
        item
        xs={12}
        sm={6}
        justifyContent='flex-end'
        alignItems='flex-end'
        sx={{ display: { sm: 'flex', xs: 'none' } }}
      >
        <Indicators
          cantItems={cantItems}
          current={current}
          handleGoto={handleInternalGoto}
        />
      </Grid>
    </Grid>
  )
}

export default Step5
